var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"news-dynamic-info"}},[_c('div',{staticClass:"title"},[_c('span',[_vm._v("新闻动态")]),_vm._v(" "),_c('dv-decoration-2',{staticStyle:{"height":"10px"}})],1),_vm._v(" "),_c('div',{staticClass:"details"},[_c('dv-scroll-board',{attrs:{"config":_vm.config}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17b4dae2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/datav/NewsDynamic.vue
// module id = null
// module chunks = 